import { render, staticRenderFns } from "./Receipt.vue?vue&type=template&id=3fd2de6f&scoped=true&"
import script from "./Receipt.vue?vue&type=script&lang=js&"
export * from "./Receipt.vue?vue&type=script&lang=js&"
import style0 from "./Receipt.vue?vue&type=style&index=0&id=3fd2de6f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd2de6f",
  null
  
)

export default component.exports